import React from 'react';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

const ClosingThoughts = () => {
  usePageTitle('Closing Thoughts');
  
  return (
    <div className="page-content">
      <h1 className="page-title">Closing Thoughts</h1>
      
        <p>
        It is worth repeating that the real goal isn't MAKING MONEY as much as it is about GAINING YOUR FREEDOM. The goal is to have TIME to DO what you want, rather than just MONEY to BUY what you want. Money is just a means to that end. A proxy. It's important to remember that at all times.
        </p>
        
        <p>
        As per the U.S. Census there are about <Link to="https://www.census.gov/quickfacts/fact/table/US/HSD410221">125 million households</Link> in the country in a population of 333 million. The U.S. Census also reported the median household income in the US to be almost <Link to="https://www.census.gov/quickfacts/fact/table/US/INC110221">$70,000</Link> and the median household wealth to be <Link to="https://www.census.gov/content/dam/Census/library/publications/2023/demo/p70br-183.pdf">$167,000</Link>. This means that half i.e. over 62 million households earn more than $70,000 a year. With some discipline and a lot of patience - and yes, luck! - a good fraction of these $70,000 households could auto-invest $500 each month in a low-cost passively-managed index find and find that in 30 years they are worth $600,000 - over 3.5X that $167K meadian. $825 a month gets them to $1,000,000 in 30 years. The 22M U.S. millionaires now actually sounds low.
        </p>

        <p>
        Some additional reflections:


        </p>
        
        <ul>
          <li>Unless you win the lottery or inherit from a rich relative, you will need to save money so that you can invest it. There is no shortcut.
          </li>
          <li>You don't need to deny yourself every pleasure in life: just do it within reason. Putting away money to invest 'off the top' is better than spending up front and then seeing how much you have left to invest - if you're like most people, then it probably won't be a lot.
          </li>
          <li>Look for tax-advantaged options such as 401(k)s, IRAs, 529s etc. They are worth it.
          </li>
          <li>The worst enemies of your hard-earned wealth are taxes, inflation and debt. As an average Joe or Maria, you have little control over the first two. So, focus on the third.
          </li>
          <li>Your best friends are discipline, patience, and time. Compound interest needs all three to work it's magic.
          </li>
        </ul>

        <p>
        Questions? Thoughts? Feedback? Please use the <Link to="https://us12.list-manage.com/contact-form?u=10915527feacbea704706808b&form_id=6b513ff2a8c5a07a19a1514a34c48aee">contact form</Link> to get in touch!
        </p>
      
        <h1 className="page-title">Good Luck!</h1>

      <Link to="/" className="back-link">
        Home
      </Link>
    </div>
  );
};

export default ClosingThoughts; 